import { createRouter, createWebHistory } from 'vue-router'
import Index from '@/pages/Index.vue'
import Admin from '@/pages/Admin.vue'
import NotFound from '@/pages/NotFound.vue'

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index,
    meta: { public: true }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta: { public: false }
  },
  {
    path: '/admin/submissions',
    name: 'AdminSubmissions',
    component: Admin,
    meta: { public: false }
  },
  {
    path: '/admin/settings',
    name: 'AdminSettings',
    component: Admin,
    meta: { public: false }
  },
  {
    path: '/admin/embed',
    name: 'AdminEmbed',
    component: Admin,
    meta: { public: false }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound,
    meta: { public: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to) => {
  if (to.meta.public === false && window.top !== window.self) {
    return { name: 'Index' }
  }
})

export default router
